"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistogramTooltipData = exports.formatHistogramData = exports.calculateAutoBucketSize = exports.getUniqueGroups = exports.yAxisTickFormat = exports.MIN_PIXELS_PER_GROUP = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
exports.MIN_PIXELS_PER_GROUP = 90;
exports.yAxisTickFormat = function (d) {
    return d === 0 ? '' : d3.format('d')(d);
};
exports.getUniqueGroups = function (data) {
    return pipe_1.default(get_1.default('groupedData'), map_1.default(get_1.default('group')))(data);
};
exports.calculateAutoBucketSize = function (chartWidth, maxDataValue, minDataValue) {
    var dataRange = maxDataValue - minDataValue;
    var pixelsForEachGroup = chartWidth / dataRange;
    if (pixelsForEachGroup >= exports.MIN_PIXELS_PER_GROUP) {
        return 1;
    }
    var pixelsForFullView = exports.MIN_PIXELS_PER_GROUP * dataRange;
    return Math.ceil(pixelsForFullView / chartWidth);
};
exports.formatHistogramData = function (data, bucketSize, chartWidth) {
    var groupedData = [];
    var subGroups = data.map(function (_a) {
        var values = _a.values, rest = tslib_1.__rest(_a, ["values"]);
        return (tslib_1.__assign({}, rest));
    });
    var minDataValue = Math.floor(d3.min(data, function (d) { return d3.min(d.values, function (v) { return v; }); }) || 0);
    var maxDataValue = Math.ceil(d3.max(data, function (d) { return d3.max(d.values, function (v) { return v; }); }) || 0);
    var numericalBucketSize = bucketSize === 'AUTO'
        ? exports.calculateAutoBucketSize(chartWidth, maxDataValue, minDataValue)
        : bucketSize;
    var numBuckets = Math.ceil((maxDataValue - minDataValue) / numericalBucketSize);
    var minBucketValue = minDataValue;
    var maxBucketValue = minDataValue + (numBuckets - 1) * numericalBucketSize;
    var _loop_1 = function (currentBucket) {
        var nextBucket = currentBucket + numericalBucketSize;
        var bucketName = currentBucket + " to " + nextBucket;
        var groupValues = data.map(function (_a) {
            var values = _a.values, ID = _a.ID;
            var numInCurrentBucket = values.filter(function (d) { return d >= currentBucket && d < nextBucket; }).length;
            return { subGroupID: ID, y: numInCurrentBucket };
        });
        groupedData.push({ group: bucketName, values: groupValues });
    };
    for (var currentBucket = minBucketValue; currentBucket <= maxBucketValue; currentBucket += numericalBucketSize) {
        _loop_1(currentBucket);
    }
    return { subGroups: subGroups, groupedData: groupedData };
};
exports.getHistogramTooltipData = function (subGroups, group) {
    return subGroups.map(function (subgroup) {
        var value = group.values.find(function (v) { return v.subGroupID === subgroup.ID; });
        return tslib_1.__assign(tslib_1.__assign({}, subgroup), { value: value });
    });
};
